import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wws7d39tvc: FaireBrandEntity = {
  token: "b_wws7d39tvc",
  type: "brand",
  name: "Madison’s Pop Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/48632f00d6a21e605deb164157b787ea9b01b48d7ce0aa000b4816bf2823cfc9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b3c386f8979297a693b876c6699f316efc7b2a68290f8a9b14c595dafb08e710.png",
  logoUrl:
    "https://cdn.faire.com/fastly/48632f00d6a21e605deb164157b787ea9b01b48d7ce0aa000b4816bf2823cfc9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b3c386f8979297a693b876c6699f316efc7b2a68290f8a9b14c595dafb08e710.png",
  location: "Palm Harbor, FL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi! I’m Madison, and I live on the west coast of Florida where I own a boutique in the small town of Dunedin\\. My shop is a little bit of everything—consignment furniture, local art, jewelry, baby clothes and, of course, lots and lots of gifts\\.\n\nAfter owning a boutique for years, I’ve learned that the best gifts are usually the ones that make you feel something\\. Sometimes they make you laugh, sometimes they’re a little inappropriate, and sometimes you see one and immediately think, “I HAVE to get this for her\\.”\n\nThat’s pretty much what you’ll find in my Faire shop\\.\n\nI love creating products around all the random little things people are obsessed with—grandkids, faith, music, mahjong, sports, pop culture, family, hobbies and a healthy dose of sarcasm\\. There’s really no serious theme around here, and I kind of like it that way\\.\n\nI just make things I think people will want to pick up, laugh at, give to someone they love, or keep for themselves\\.\n\nHopefully your customers find a few of those here too\\. ❤️",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.964Z",
    importedBy: "entity-db-cli",
  },
};
